const Request = require('./BaseRequest')
const AccountGraph = require('../graph/AccountGraph')

module.exports = class AccountRequest extends Request
{
    constructor(apiDomain)
    {
        super(apiDomain)
        this.graph = new AccountGraph(this.apiDomain)
    }

    swrAccount(accountId, useSwr = true)
    {
        let args = {accountId: accountId}
        let { type, query } = this.graph.accountQuery(['id', 'name'], args)

        if (useSwr) return this.graph.swrRequest(query, this.swrOptions, type)
        return this.graph.request(query, args, type)
    }
    
    swrAccountByUserId(userId)
    {
        let args = {userId: userId}
        let { type, query } = this.graph.accountByUserIdQuery(['id', 'accountId', 'name', 'created_at'], args)
        return this.graph.swrRequest(query, this.swrOptions, type)
    }

    swrAccountDomains(accountId)
    {
        let args = {accountId: accountId}
        let { type, query } = this.graph.accountDomainQuery(['id', 'domainId', 'domain','misc_data'], args)
        return this.graph.swrRequest(query, this.swrOptions, type)
    }

    swrAccountSsl(accountId)
    {
        let args = {accountId: accountId}
        let { type, query } = this.graph.accountSslQuery(['id', 'type', 'domain','is_paid','expiry_date', 'status'], args)
        return this.graph.swrRequest(query, this.swrOptions, type)
    }

    swrAccountEmails(accountId)
    {
        let args = {accountId: accountId}
        let { type, query } = this.graph.accountEmailQuery(['id', 'email','password','status'], args)
        return this.graph.swrRequest(query, this.swrOptions, type)
    }

    async createAccount(options)
    {
        let args = { ...options }
        let { type, query } = this.graph.createAccountMutation(['userId', 'accountId', 'redirect', 'errors{field, messages}'])
        let data = await this.graph.request(query, args, type)
        return data
    }

    async createAccountByContact(options)
    {
        let args = { ...options }
        let { type, query } = this.graph.createAccountByContactMutation(['userId', 'accountId', 'redirect', 'errors{field, messages}'])
        let data = await this.graph.request(query, args, type)
        return data
    }

    swrAccountData(accountId, name)
    {
        let args = {accountId: accountId, name: name}
        let { type, query } = this.graph.accountDataQuery(['data'], args)
        return this.graph.swrRequest(query, this.swrOptions, type)
    }

    swrAccountProfile(accountId)
    {
        let args = {accountId: accountId}
        let { type, query } = this.graph.accountProfileQuery([
            'userId', 'name', 'first_name', 'last_name', 'phone', 'avatar', 'is_active',
            {timezone: ['location']}, {user: ['id']}
        ], args)
        return this.graph.swrRequest(query, this.swrOptions, type)
    }

    swrUserProfile(userId)
    {
        let args = {userId: userId}
        let { type, query } = this.graph.userProfileQuery([
            'name', 'first_name', 'last_name', 'phone', 'avatar',
            {timezone: ['location']}, {user: ['id', 'auth_key', 'email', 'hashEmail']}, {account: ['accountId']}
        ], args)
        return this.graph.swrRequest(query, this.swrOptions, type)
    }

    swrAddress(userId)
    {
        let args = {userId: userId}
        let { type, query } = this.graph.addressQuery([
            'address', 'city', 'postal_code',
            {country: ['id', 'name', 'alpha2', 'alpha3']}, {province: ['id', 'name', 'code']}
        ], args)
        return this.graph.swrRequest(query, this.swrOptions, type)
    }

    swrSocialMedia(accountId, user_id)
    {
        let args = {accountId: accountId, name: 'account_profile_socialmedia', extract_key: 'user_id', extract_value: user_id}
        let { type, query } = this.graph.profileDataQuery(['data'], args)
        return this.graph.swrParsedRequest(query, this.swrOptions, type, 'data')
    }

    swrShakleeInfo(accountId, user_id)
    {
        let args = {accountId: accountId, name: 'account_shaklee', extract_key: 'user_id', extract_value: user_id}
        let { type, query } = this.graph.profileDataQuery(['data'], args)
        return this.graph.swrParsedRequest(query, this.swrOptions, type, 'data')
    }

    swrTrialInfo(accountId, user_id)
    {
        let args = {accountId: accountId, name: 'account_user_trial_info', extract_key: 'user_id', extract_value: user_id}
        let { type, query } = this.graph.profileDataQuery(['data'], args)
        return this.graph.swrParsedRequest(query, this.swrOptions, type, 'data')
    }

    swrBlog(accountId, user_id)
    {
        let args = {accountId: accountId, name: 'account_user_blog', extract_key: 'user_id', extract_value: user_id}
        let { type, query } = this.graph.profileDataQuery(['data'], args)
        return this.graph.swrParsedRequest(query, this.swrOptions, type, 'data')
    }

    swrBranding(accountId, user_id)
    {
        let args = {accountId: accountId, name: 'account_user_branding', extract_key: 'user_id', extract_value: user_id}
        let { type, query } = this.graph.profileDataQuery(['data'], args)
        return this.graph.swrParsedRequest(query, this.swrOptions, type, 'data')
    }

    swrLiveStream(accountId, user_id)
    {
        let args = {accountId: accountId, name: 'account_user_livestream', extract_key: 'user_id', extract_value: user_id}
        let { type, query } = this.graph.profileDataQuery(['data'], args)
        return this.graph.swrParsedRequest(query, this.swrOptions, type, 'data')
    }

    swrCalendarSetting(accountId)
    {
        let args = {accountId: accountId}
        let { type, query } = this.graph.calendarSettingQuery([
            {timezone: ['php']}
        ], args)
        return this.graph.swrRequest(query, this.swrOptions, type)
    }

    swrTimezoneSetting(id)
    {
        let args = {id: id}
        let { type, query } = this.graph.timezoneSettingQuery(['id','name', 'alternate_name', 'location', 'code', 'utc', 'php'], args)
        return this.graph.swrRequest(query, this.swrOptions, type)
    }

    //Trial User Registration
    async saveTrialUser(optional={})
    {
        let args = { ...optional }
        let { type, query } = this.graph.saveTrialUserMutation(['username','first_name', 'last_name', 'email', 'phone', 'password', 'confirm_password', 'shaklee_status', 'referral', 'is_agreed', 'hashEmail'], args)
        let data = await this.graph.request(query, args, type)
        return data
    }

    async shakleeInfo(accountId, user_id)
    {
        let args = {accountId: accountId, name: 'account_shaklee', extract_key: 'user_id', extract_value: user_id}
        let { type, query } = this.graph.profileDataQuery(['data'], args)
        let data = await this.graph.request(query, args, type)
        return data
    }

    async accountProfile(accountId)
    {
        let args = {accountId: accountId}
        let { type, query } = this.graph.accountProfileQuery([
            'userId', 'name', 'first_name', 'last_name', 'phone', 'avatar', 'is_active',
            {timezone: ['location']}, {user: ['id']}
        ], args)
        let data = await this.graph.request(query, args, type)
        return data
    }

    swrTrialUser(email)
    {
        let args = {email: email}
        let { type, query } = this.graph.trialUserQuery(['email', 'username', 'account_activation_token'], args)
        return this.graph.swrRequest(query, this.swrOptions, type)
    }

    swrSendActivationEmail(email)
    {
        let args = {email: email}
        let { type, query } = this.graph.sendActivationEmailQuery(['email'], args)
        return this.graph.swrRequest(query, this.swrOptions, type)
    }

    swrAccountSetting(name)
    {
        let args = {name: name}
        let { type, query } = this.graph.accountSettingQuery(['name', 'data'], args)
        return this.graph.swrRequest(query, this.swrOptions, type)
    }

    swrContactUser(email)
    {
        let args = {email: email}
        let { type, query } = this.graph.contactUserQuery([
            'id', 'email', 'hashEmail',
        ], args)
        return this.graph.swrRequest(query, this.swrOptions, type)
    }

    swrAccountNotificationSetting(userId)
    {
        let args = {userId: userId}
        let { type, query } = this.graph.accountNotificationQuery(['name', 'data'], args)
        return this.graph.swrRequest(query, this.swrOptions, type)
    }

    //Account Profile Data
    async saveAccountProfileData(userId, name, category, content_id)
    {
        let args = {user_id: userId, name: name, category: category, content_id: content_id}
        let { type, query } = this.graph.saveAccountDataMutation(['id','account_id', 'name', 'data'], args)
        let data = await this.graph.request(query, args, type)
        return data
    }

    swrAccountProfileData(accountId, name)
    {
        let args = {accountId: accountId, name: name}
        let { type, query } = this.graph.accountProfileDataQuery(['id', 'account_id', 'name', 'data'], args)
        return this.graph.swrRequest(query, this.swrOptions, type)
    }
    
    //Trial User Registration
    async smartStart(userId, value, date_completed, other_data=null)
    {
        let args = {userId: userId, value: value, date_completed: date_completed, other_data: other_data }
        let { type, query } = this.graph.smartStartMutation(['data'], args)
        let data = await this.graph.request(query, args, type)
        return data
    }

    swrAccountActivity(userId, name)
    {
        let args = {userId: userId, name: name}
        let { type, query } = this.graph.accountActivityQuery(['data'], args)
        return this.graph.swrRequest(query, this.swrOptions, type)
    }

    swrAccountAllActivity(userId)
    {
        let args = {userId: userId}
        let { type, query } = this.graph.accountAllActivityQuery(['data'], args)
        return this.graph.swrRequest(query, this.swrOptions, type)
    }

    getUserByEmail(email) {
        let args = { email: email }
        let { type, query } = this.graph.trialUserQuery(['email', 'username', 'account_activation_token'], args)
        return this.graph.request(query, args, type)
    }
}